import type { IconCode } from "@components/Atoms/Icon/LucideIcon";
import { cn } from "@core-ui/utils/cn";
import { useViewSurfaceVariant } from "@ext/markdown/elements/view/models/ViewSurfaceVariant";
import {
	PanelEmptyState,
	PanelEmptyStateDescription,
	PanelEmptyStateIcon,
	PanelEmptyStateTitle,
} from "@ui-kit/FloatingPanel";

interface ViewEmptyStateProps {
	icon: IconCode;
	title: string;
	description: string;
	className?: string;
}

const ViewEmptyState = ({ icon, title, description, className }: ViewEmptyStateProps) => {
	const isPanel = useViewSurfaceVariant() === "panel";

	return (
		<PanelEmptyState className={cn("select-none", !isPanel && "h-auto py-8", className)} data-focusable="true">
			<PanelEmptyStateIcon icon={icon} />
			<PanelEmptyStateTitle>{title}</PanelEmptyStateTitle>
			<PanelEmptyStateDescription className="max-w-64">{description}</PanelEmptyStateDescription>
		</PanelEmptyState>
	);
};

export default ViewEmptyState;
